<template>
    <form method='POST' v-on:submit.prevent="handleSubmit">
        <div class='m-wizard m-wizard--1 m-wizard--success m-wizard--step-first' id='m_wizard'>
            <!--begin: Message container -->
            <div class='m-portlet__padding-x'>
                <!-- Here you can put a message or alert -->
            </div>
            <!--end: Message container -->
            <!--begin: Form Wizard Head -->
            <div class='m-wizard__head m-portlet__padding-x'>
                <!--begin: Form Wizard Progress -->
                <div class='m-wizard__progress'>
                    <div class='progress'>
                        <div class='progress-bar' role='progressbar' aria-valuenow='100' aria-valuemin='0'
                             aria-valuemax='100' style='width: calc(25% + 28px);'></div>
                    </div>
                </div>
                <!--end: Form Wizard Progress -->
                <!--begin: Form Wizard Nav -->
                <div class='m-wizard__nav'>
                    <div class='m-wizard__steps'>
                        <div class='m-wizard__step m-wizard__step--current' m-wizard-target='m_wizard_form_step_1'>
                            <div class='m-wizard__step-info'>
                                <a href='#' class='m-wizard__step-number'>
                                                <span>
                                                   <span>
                                                      1
                                                   </span>
                                                </span>
                                </a>
                                <div class='m-wizard__step-line'>
                                    <span></span>
                                </div>
                                <div class='m-wizard__step-label'>
                                    Base Information
                                </div>
                            </div>
                        </div>
                        <div class='m-wizard__step' m-wizard-target='m_wizard_form_step_2'>
                            <div class='m-wizard__step-info'>
                                <a href='#' class='m-wizard__step-number'>
                                                <span>
                                                   <span>
                                                      2
                                                   </span>
                                                </span>
                                </a>
                                <div class='m-wizard__step-line'>
                                    <span></span>
                                </div>
                                <div class='m-wizard__step-label'>
                                    Inputs
                                </div>
                            </div>
                        </div>
                        <div class='m-wizard__step' m-wizard-target='m_wizard_form_step_3'>
                            <div class='m-wizard__step-info'>
                                <a href='#' class='m-wizard__step-number'>
                                                <span>
                                                   <span>
                                                      3
                                                   </span>
                                                </span>
                                </a>
                                <div class='m-wizard__step-line'>
                                    <span></span>
                                </div>
                                <div class='m-wizard__step-label'>
                                    Validation
                                </div>
                            </div>
                        </div>
                        <div class='m-wizard__step' m-wizard-target='m_wizard_form_step_4'>
                            <div class='m-wizard__step-info'>
                                <a href='#' class='m-wizard__step-number'>
                                                <span>
                                                   <span>
                                                      4
                                                   </span>
                                                </span>
                                </a>
                                <div class='m-wizard__step-line'>
                                    <span></span>
                                </div>
                                <div class='m-wizard__step-label'>
                                    Options
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end: Form Wizard Nav -->
            </div>
            <!--end: Form Wizard Head -->
            <!--begin: Form Wizard Form-->
            <div class='m-wizard__form'>
                <!--
1) Use m-form--label-align-left class to alight the form input lables to the right
2) Use m-form--state class to highlight input control borders on form validation
-->
                <!--begin: Form Body -->
                <div class='m-portlet__body'>
                    <!--begin: Form Wizard Step 1-->
                    <div class='m-wizard__form-step m-wizard__form-step--current' id='m_wizard_form_step_1'>
                        <div class='row'>
                            <div class='col-xl-8 offset-xl-2'>
                                <div class='m-form__section m-form__section--first'>
                                    <div class='m-form__heading'>
                                        <h3 class='m-form__heading-title'>
                                            Module Details
                                        </h3>
                                    </div>
                                    <div class='form-group m-form__group'>
                                        <label for='moduleName'>
                                            Module Name
                                        </label>
                                        <input type='text' class='form-control m-input' id='moduleName' v-model="form.moduleName"
                                               placeholder='Enter module Name'>
                                        <span class='m-form__help'>
                        We'll never share your email with anyone else.
                    </span>
                                    </div>
                                    <div class='form-group m-form__group row'>
                                        <div class='form-group m-form__group col-lg-6'>
                                            <label for='collection'>
                                                Collection
                                            </label>
                                            <input type='text' class='form-control m-input' id='collection' v-model="form.collection"
                                                   placeholder='Enter collection'>
                                            <span class='m-form__help'>
                        We'll never share your email with anyone else.
                    </span>
                                        </div>
                                        <div class='form-group m-form__group col-lg-6'>
                                            <label for='route'>
                                                Route
                                            </label>
                                            <input type='text' class='form-control m-input' id='route' v-model="form.route"
                                                   placeholder='Enter route'>
                                            <span class='m-form__help'>
                        We'll never share your email with anyone else.
                    </span>
                                        </div>
                                    </div>
                                </div>
                                <div class='m-separator m-separator--dashed m-separator--lg'></div>
                                <div class='m-form__section'>
                                    <div class='m-form__heading'>
                                        <h3 class='m-form__heading-title'>
                                            Middleware Settings
                                        </h3>
                                    </div>
                                    <div class='form-group m-form__group row'>
                                        <div class='col-lg-6 m-form__group-sub'>
                                            <label class='form-control-label'>
                                                * Middlewares:
                                            </label>
                                            <div class='m-checkbox-inline'>
                                                <label class='m-checkbox' v-for='(value) in middlewares'
                                                       v-bind:key='value'>
                                                    <input type='checkbox' :id="value" :value='value' v-model="form.middlewares">
                                                    {{value}}
                                                    <span></span>
                                                </label>
                                            </div>
                                            <span class='m-form__help'>
                                                            Please select user group
                                                         </span>
                                        </div>
                                    </div>
                                </div>
                                <div class='m-separator m-separator--dashed m-separator--lg'></div>
                                <div class='m-form__section'>
                                    <div class='m-form__heading'>
                                        <h3 class='m-form__heading-title'>
                                            Form Settings
                                        </h3>
                                    </div>
                                    <div class='form-group m-form__group row'>
                                        <div class='col-lg-6 m-form__group-sub'>
                                            <label for='form'>
                                                Form Class
                                            </label>
                                            <input type='text' class='form-control m-input' id='form' placeholder='Enter form class' value='m-form m-form--state' v-model="form.form">
                                            <span class='m-form__help'>
                        We'll never share your email with anyone else.
                    </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end: Form Wizard Step 1-->
                    <!--begin: Form Wizard Step 2-->
                    <div class='m-wizard__form-step' id='m_wizard_form_step_2'>
                        <div class='row'>
                            <div class='col-xl-12'>
                                <Builder :models="models" :active_panel="active_panel" :panels="panels" v-on:updatePanel='updatePanelParent' v-on:setActivePanel="setActivePanel" v-on:updateInputs='updateInputs'></Builder>
                            </div>
                        </div>
                    </div>
                    <!--end: Form Wizard Step 2-->
                    <!--begin: Form Wizard Step 3-->
                    <div class='m-wizard__form-step' id='m_wizard_form_step_3'>
                        <div class='row'>
                            <div class='col-12'>
                                <Validation :inputs="inputs" v-bind:create-rules="createRules" v-bind:update-rules="updateRules" v-on:createRules='updateCreateRuleData' v-on:updateRules='updateUpdateRuleData'></Validation>
                            </div>
                        </div>
                    </div>
                    <!--end: Form Wizard Step 3-->
                    <!--begin: Form Wizard Step 4-->
                    <div class='m-wizard__form-step' id='m_wizard_form_step_4'>
                        <div class='row'>
                            <div class='col-xl-8 offset-xl-2'>
                                <Options :options="options" v-bind:softdelete="'1'" :inputs="inputs" v-on:updateOptions="updateOptions"></Options>
                            </div>
                        </div>
                    </div>
                    <!--end: Form Wizard Step 4-->
                </div>
                <!--end: Form Body -->
                <!--begin: Form Actions -->
                <div class='m-portlet__foot m-portlet__foot--fit m--margin-top-40'>
                    <div class='m-form__actions m-form__actions m--margin-top-40'>
                        <div class='row'>
                            <div class='col-lg-2'></div>
                            <div class='col-lg-4 m--align-left'>
                                <a href='#' class='btn btn-secondary m-btn m-btn--custom m-btn--icon'
                                   data-wizard-action='prev'>
                                                   <span>
                                                      <i class='la la-arrow-left'></i>
                                                      &nbsp;&nbsp;
                                                      <span>
                                                         Back
                                                      </span>
                                                   </span>
                                </a>
                            </div>
                            <div class='col-lg-4 m--align-right'>
                                <a href='#' class='btn btn-primary m-btn m-btn--custom m-btn--icon'
                                   data-wizard-action='submit' @click="handleSubmit">
                                                   <span>
                                                      <i class='la la-check'></i>
                                                      &nbsp;&nbsp;
                                                      <span>
                                                         Submit
                                                      </span>
                                                   </span>
                                </a>
                                <a href='#' class='btn btn-warning m-btn m-btn--custom m-btn--icon'
                                   data-wizard-action='next'>
                                                   <span>
                                                      <span>
                                                         Save &amp; Continue
                                                      </span>
                                                      &nbsp;&nbsp;
                                                      <i class='la la-arrow-right'></i>
                                                   </span>
                                </a>
                            </div>
                            <div class='col-lg-2'></div>
                        </div>
                    </div>
                </div>
                <!--end: Form Actions -->
            </div>
            <!--end: Form Wizard Form-->
        </div>
    </form>
</template>

<script>
import Builder from '../../core/module/Builder'
import Validation from '../../core/module/Validation'
import Options from '../../core/module/Options'

export default {
  name: 'ModuleCreate',
  components: {Options, Validation, Builder},
  data () {
    return {
      middlewares: [],
      active_panel: '1',
      models: [],
      panels: {},
      inputs: {},
      createRules: [],
      updateRules: [],
      options: {},
      form: {
        middlewares: [],
        form: 'm-form m-form--state'
      },
      submitData: {
        moduleName: '',
        collection: '',
        route: '',
        middlewares: [],
        validation: {
          CREATE: {},
          UPDATE: {}
        },
        options: {
          softdeletes: 1,
          fillable: [],
          searchColumns: {},
          searchColumnLabels: {},
          resource: [],
          show_list: []
        },
        inputs: {},
        form: 'm-form m-form--state'
      }
    }
  },
  created: function () {
    this.panels = {}
  },
  watch: {
    'form.route': {
      handler (val) {
        if (val !== undefined && val.startsWith('/') === false) {
          this.form.route = '/' + this.form.route.toLowerCase()
        }
      },
      deep: true
    },
    'form.collection': {
      handler (val) {
        if (val !== undefined) {
          this.form.collection = this.form.collection.toLowerCase()
        }
      },
      deep: true
    }
  },
  methods: {
    updatePanelParent (variable) {
      this.panels = Object.assign({}, variable)
    },
    updateInputs (variable) {
      this.inputs = Object.assign({}, variable)

      let hlp = []
      for (let i in variable) {
        hlp.push({name: variable[i], resource: 1, show_list: 1, searchColumns: 1, searchColumnLabels: variable[i], searchType: 'text'})
      }

      this.options = Object.assign({}, {extra: hlp, softdeletes: 1})
    },
    setActivePanel (variable) {
      this.active_panel = variable
    },
    updateCreateRuleData (variable) {
      this.createRules = variable
    },
    updateUpdateRuleData (variable) {
      this.updateRules = variable
    },
    updateOptions (variable) {
      this.options = Object.assign({}, variable)
    },
    handleSubmit: function () {
      this.submitData.moduleName = this.form.moduleName
      this.submitData.collection = this.form.collection
      this.submitData.route = this.form.route
      this.submitData.middlewares = this.form.middlewares
      this.submitData.form = this.form.form

      let create = {}

      for (let it in this.createRules) {
        create[this.createRules[it].key] = []
      }

      for (let it in this.createRules) {
        create[this.createRules[it].key].push(this.createRules[it].value + this.createRules[it].value2)
      }

      this.submitData.validation.CREATE = create

      let update = {}

      for (let it in this.updateRules) {
        update[this.updateRules[it].key] = []
      }

      for (let it in this.updateRules) {
        update[this.updateRules[it].key].push(this.updateRules[it].value + this.updateRules[it].value2)
      }

      this.submitData.validation.UPDATE = update

      this.submitData.options.softdeletes = this.options.softdeletes

      let fillable = []

      for (let it in this.inputs) {
        fillable.push(this.inputs[it])
      }

      this.submitData.options.fillable = fillable

      let searchColumns = {}
      let searchColumnLabels = {}
      let resource = []
      let showList = []

      for (let it in this.options.extra) {
        if (this.options.extra[it].searchColumns) {
          searchColumns[this.options.extra[it].name] = this.options.extra[it].searchType
          searchColumnLabels[this.options.extra[it].name] = this.options.extra[it].searchColumnLabels
        }
        if (this.options.extra[it].show_list) {
          showList.push(this.options.extra[it].name)
        }

        if (this.options.extra[it].resource) {
          resource.push(this.options.extra[it].name)
        }
      }

      this.submitData.options.searchColumns = searchColumns
      this.submitData.options.searchColumnLabels = searchColumnLabels
      this.submitData.options.resource = resource
      this.submitData.options.show_list = showList

      this.submitData.inputs = this.panels

      this.$http.post(process.env.API_URL + '/api/v1/admin/module-builder/create', this.submitData, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        this.errorMessage = []
        if (res.data && res.data.data !== 'undefined') {
          localStorage.removeItem('endpoints')

          this.$router.push({path: '/admin/modules/index'})
        } else {
          let errors = res.response.data.errors

          let errorArray = []
          for (let er in errors) {
            errorArray[er] = errors[er]
          }

          this.errorMessage = errorArray
        }
      }).catch(res => {

      })
    }
  },
  mounted: function () {
    this.$emit('updateTitle', 'Create Module')
    window.mWizard('m_wizard', {
      startStep: 1
    })

    let self = this
    this.$http
      .get(process.env.API_URL + '/api/v1/admin/settings/get-middlewares', {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.middlewares = res.data.data
      }).catch(res => {

      })

    this.$http
      .get(process.env.API_URL + '/api/v1/admin/settings/get-models', {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.models = res.data.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/module/ModuleCreate.vue